import {
	Box,
	Checkbox,
	Chip,
	FormControl,
	ListItemText,
	MenuItem,
	OutlinedInput,
	Select,
	type SelectChangeEvent,
} from '@mui/material'
import React from 'react'

import type { GridFilterOption } from '../types'

type Props = {
	value: string[]
	options: GridFilterOption[]
	placeholder: string
	onChange: (value: string[]) => void
}

export const MultiSelectFilter: React.FC<Props> = ({ value, options, placeholder, onChange }) => (
	<FormControl fullWidth size="small" variant="standard" onClick={(e) => e.stopPropagation()}>
		<Select<string[]>
			multiple
			value={value}
			onChange={(e: SelectChangeEvent<string[]>) => {
				const next = e.target.value
				onChange(typeof next === 'string' ? next.split(',') : next)
			}}
			onKeyDown={(e) => e.stopPropagation()}
			displayEmpty
			renderValue={(selected) => {
				if (selected.length === 0) {
					return <Box sx={{ color: 'text.disabled', py: '3px' }}>{placeholder}</Box>
				}
				return (
					<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, py: '3px' }}>
						{selected.map((v) => {
							const option = options.find((opt) => opt.value === v)
							return <Chip key={v} label={option?.label ?? v} size="small" />
						})}
					</Box>
				)
			}}
			input={<OutlinedInput size="small" />}
		>
			{options.map((opt) => (
				<MenuItem key={opt.value} value={opt.value}>
					<Checkbox checked={value.indexOf(opt.value) > -1} />
					<ListItemText primary={opt.label} />
				</MenuItem>
			))}
		</Select>
	</FormControl>
)
